import { render, staticRenderFns } from "./history-modal.vue?vue&type=template&id=151fc348&scoped=true&"
import script from "./history-modal.vue?vue&type=script&lang=js&"
export * from "./history-modal.vue?vue&type=script&lang=js&"
import style0 from "./history-modal.vue?vue&type=style&index=0&id=151fc348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fc348",
  null
  
)

export default component.exports